import GoalsIndexChart from '@components/Charts/GoalIndex/GoalIndexChartWrapper'
import { Flex } from 'antd'

import { useNavigate } from '@suntex.core/nav'
import { goalsIndexPhaseOptions } from '@suntex.fim/assessment'
import {
  $EntityLevel,
  GoalsIndexPhase,
  SpecialGradeLevel
} from '@suntex.fim/enums'
import { useEntityContext } from '@suntex.fim/nav'
import { Button, LevelSelect } from '@suntex.fim/ui'

function GoalsIndex({
  phase,
  setPhase,
  id,
  year,
  grade
}: {
  phase: GoalsIndexPhase
  setPhase: (phase: GoalsIndexPhase) => void
  id?: number
  year?: string
  grade?: SpecialGradeLevel
}) {
  const navigate = useNavigate()
  const { entityLevel: apiLevel, entityId: apiId } = useEntityContext()

  const role = $EntityLevel.describe(apiLevel).slug

  return (
    <Flex vertical gap="20px" className="graph-tiles team-activity">
      <Flex
        align="center"
        className="graph-tiles__title"
        justify="space-between"
      >
        <h4 className="title">Goals Index</h4>
        <div className="right">
          <LevelSelect
            value={phase}
            onChange={(newLevel) => setPhase(newLevel)}
            options={goalsIndexPhaseOptions}
          />
          <Button
            onClick={() =>
              navigate(`/${role}/${id}/assessment-report/algebra-goals-metric`)
            }
          >
            Algebra
          </Button>
        </div>
      </Flex>
      <Flex vertical align="center" className="graph-tiles__graph">
        <div className="stat">
          <GoalsIndexChart
            id={apiId!}
            level={apiLevel}
            year={year!}
            phase={phase}
            grade={grade!}
          />
        </div>
      </Flex>
    </Flex>
  )
}

export default GoalsIndex
